import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import LayoutAuth from "../components/layoutAuth";
import { authService } from "../services/auth";
import { giftsService } from "../services/gifts";

const Register = () => {
  const [searchParams] = useSearchParams();
  const giftHash = searchParams.get("gift") || "";
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [gift, setGift] = useState(null);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!giftHash) return;
    giftsService.getClaim(
      giftHash,
      (response) => {
        setGift(response.data);
        if (response.data?.recipient_email) {
          setEmail(response.data.recipient_email);
        }
      },
      () => setGift(null)
    );
  }, [giftHash]);

  const submit = (event) => {
    event.preventDefault();
    setLoading(true);
    const form = event.target.elements;
    authService.register(
      { full_name: form.full_name.value, email: form.email.value, password: form.password.value },
      () => authService.fetchUser(() => { window.location = "/onboarding/"; }),
      (requestError) => {
        setError(requestError.response?.data?.email || requestError.response?.data?.error || "Could not create your account.");
        setLoading(false);
      }
    );
  };

  return (
    <LayoutAuth title="Create your account">
      {gift ? (
        <div className="mb-5 rounded-lg border border-theme-secondary bg-theme-secondary px-3.5 py-3 text-left">
          <p className="text-[13px] font-semibold text-theme-text">
            You got gifted a content site
          </p>
          <p className="mt-1 text-[12.5px] text-theme-text opacity-60">
            <span className="font-medium text-theme-text opacity-100">{gift.name}</span>
            {" from "}
            {gift.gifter_email_masked}
          </p>
        </div>
      ) : null}
      <form onSubmit={submit} className="space-y-3.5">
        {error && (
          <div className="rounded-lg border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-500">
            {error}
          </div>
        )}
        <label className="block text-[12.5px] font-medium">Full name<input name="full_name" required className="mt-1.5 block w-full rounded-lg border border-theme-secondary px-3.5 py-2.5 text-[13.5px] font-normal" /></label>
        <label className="block text-[12.5px] font-medium">Email address<input name="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 block w-full rounded-lg border border-theme-secondary px-3.5 py-2.5 text-[13.5px] font-normal" /></label>
        <label className="block text-[12.5px] font-medium">Password<input name="password" type="password" required minLength={8} className="mt-1.5 block w-full rounded-lg border border-theme-secondary px-3.5 py-2.5 text-[13.5px] font-normal" /></label>
        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-lg bg-theme-primary py-2.5 text-sm font-semibold text-theme-button mt-1.5 disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {loading ? "Creating account..." : "Create account"}
        </button>
        <p className="text-center text-xs opacity-60">Already have an account? <Link to="/login/" className="text-theme-primary font-medium">Sign in</Link></p>
      </form>
    </LayoutAuth>
  );
};

export default Register;
